/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prep_TitleInputs */



/**
* | output |
* | --- |
* | "Before the conversation" |
*
* @param {Notifications_Prep_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const notifications_prep_title = /** @type {((inputs?: Notifications_Prep_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prep_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voor het gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avant la conversation")
	return /** @type {LocalizedString} */ ("Before the conversation")
});